export default __webpack_public_path__ + "media/images/logo-a3f8aa7e174564ec304037f14ac5a18a.svg";